// Check if browser is Safari/Webkit

export default () => {
  // alert(navigator.userAgent.toLowerCase())
  const userAgent = navigator.userAgent.toLowerCase();
  return (userAgent.includes('webkit') || userAgent.includes('crios')) && !userAgent.includes('chrome');
}
